/** Prefer the current website lockup (leaf + CompareYourFootprint) over the legacy PNG. */
export const CYF_LOGO_ON_DARK_BACKGROUND =
  'https://s3.eu-west-2.amazonaws.com/downloads.compareyourfootprint.com/branding/compareyourfootprint/CYF_Logos_CYF_logo_horizontal_fullcolour_inverted.png';

const CYF_DARK_WORDMARK = /CYF_Logos_CYF_logo_horizontal_fullcolour(?!_inverted)/i;

/**
 * True when this host is Compare Your Footprint (whiteLabelId 0 / missing), not a partner WL.
 * @param {object} [wlSettings]
 * @returns {boolean}
 */
export const isDefaultCyfBrand = (wlSettings = {}) => {
  const id = wlSettings.whiteLabelId;
  return id === undefined || id === null || String(id) === '0';
};

/**
 * Pick a logo that stays visible on the dark brand / login backgrounds.
 * @param {string|null|undefined} url
 * @param {{ forceCyf?: boolean }} [options]
 * @returns {string|null}
 */
export const logoForDarkBackground = (url, { forceCyf = true } = {}) => {
  if (!forceCyf) return url || null;
  if (!url) return CYF_LOGO_ON_DARK_BACKGROUND;
  if (/inverted/i.test(url)) return url;
  if (CYF_DARK_WORDMARK.test(url)) return CYF_LOGO_ON_DARK_BACKGROUND;
  return url;
};

/**
 * Resolve login + header logos from white-label settings.
 * @param {object} [wlSettings]
 * @returns {{ logo: string|null, appTopLeftLogo: string|null }}
 */
export const resolveCyfLogos = (wlSettings = {}) => {
  const forceCyf = isDefaultCyfBrand(wlSettings);
  const login = logoForDarkBackground(wlSettings.logo, { forceCyf });
  const header = logoForDarkBackground(wlSettings.appTopLeftLogo || wlSettings.logo, { forceCyf });
  return { logo: login, appTopLeftLogo: header };
};
